import React from 'react';
import { DropdownItemProps } from './types';
import { NoSSRComponent } from '@/migrated-widgets/table-map/utils/ssr';

function DropdownItemComponent({ children, onHoverClass = 'hover:bg-gray-200 duration-200', textAlign = 'text-left', padding = 'p-2', className, ...rest }: DropdownItemProps) {
  return (
    <div className={
      ['cursor-pointer', onHoverClass, textAlign, padding, className].join(' ')
    }  {...rest}>
      {children}
    </div>
  )
}

export const DropdownItem = NoSSRComponent(DropdownItemComponent);